import React from 'react';

/**
 * Le dernier filet — il attrape ce qu'aucun `try` n'a attrapé.
 *
 * 🔴 IL VIVAIT À LA LIGNE 38 D'`App.js`, ENTRE 500 AUTRES, ET IL A DÛ SORTIR.
 * Le lot RU8-a remonte `LanguageProvider` au-dessus de `ThemeModeProvider`
 * (la direction est une propriété de la langue, le thème en dépend). Ces deux
 * fournisseurs vivent désormais dans `index.js` — donc **hors de la portée
 * d'un filet resté dans `App`**. Le déplacer coûtait un fichier ; le laisser
 * coûtait la couverture des deux fournisseurs qu'on venait de déplacer.
 *
 * ⚠️ IL NE CONSOMME RIEN, ET C'EST CE QUI L'AUTORISE À ÊTRE TOUT EN HAUT —
 * mesuré avant de le déplacer : ni MUI, ni thème, ni traduction. Il rend un
 * `<div>` nu. *Un filet qui dépend de ce qu'il protège tombe avec lui* : si
 * l'écran de secours avait besoin du thème, une panne du thème le rendrait
 * muet — exactement au moment où il sert.
 *
 * 🟡 ET C'EST POURQUOI SON MESSAGE N'EST PAS TRADUIT. Le seul contexte capable
 * de le traduire est `LanguageProvider`, qui est **sous** lui. Le traduire
 * demanderait de le placer dessous, donc de ne plus couvrir le fournisseur de
 * langue — *l'écran de secours ne peut pas parler la langue de l'utilisateur
 * ET survivre à la panne de ce qui la lui donne.* Dette assumée, pas oubli.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erreur capturée par ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Une erreur s'est produite.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
